function BIcon({ name, className = "", ...props }) {
	return <i className={`bi bi-${name} ${className}`} {...props}></i>;
}
export default BIcon;
